
import { defineComponent } from 'vue'

export default defineComponent({
  computed: {
    currentLanguage(): string {
      return this.$store.getters.getAppLanguage
    },
  },
})
